import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sessao-wa',
  templateUrl: './sessao-wa.component.html',
  styleUrls: ['./sessao-wa.component.scss']
})
export class SessaoWaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  AbrirWA(){
    window.open("https://wa.me/qr/RHSXPLQGLXH2J1",'_blank')
  }

}
